<template>
	<div class="col-12 product-details mt-4" v-if="uicontrol.ready">
		<div class="product-details-header">
			<div class="tab-header text-uppercase" :class="{ 'active' : iKey == uicontrol.active_tab }" v-for="(item, iKey) in tabs" @click="uicontrol.active_tab = iKey">
				{{ item.title }}
			</div>
		</div>
		<div class="product-details-body">
			<div class="tab-content" :class="{ 'visible' : iKey == uicontrol.active_tab }" v-for="(item, iKey) in tabs">
				<component :is="item.content.type" :data="item.content.value"></component>
			</div>
		</div>
	</div>
</template>

<script>

import Html from '@/Components/Product/ProductDetailsContentTypes/Html.vue';
import KeyValueTable from '@/Components/Product/ProductDetailsContentTypes/KeyValueTable.vue'
import Accordion from "@/Components/Product/ProductDetailsContentTypes/Accordion.vue";
import { contact_information, store as storeConfig } from "~app_root/public/tv/app.config";

export default {
	name: "ProductDetails",
	props: ['product'],
	data() {
		return {
			tabs: null,
			product_attribute_options: [],
			uicontrol: {
				active_tab: 0,
				ready : false
			}
		}
	},
	components: {
		Html,
		KeyValueTable,
		Accordion
	},
	mounted() {
		this.buildProductAttributeOptionsArray();
		this.loadProductDetailsTabs();
		this.uicontrol.ready = true;
	},
	methods: {
		loadProductDetailsTabs() {

			const availableTabs = [
				{
					id : 'description',
					title: this.$page.props.translations.description,
					content: {
						type: 'Html',
						value: this.product.translation.description
					}
				},
				{
					id : 'specs',
					title: this.$page.props.translations.specs,
					content: {
						type: "KeyValueTable",
						value: this.product_attribute_options
					}
				},
				{
					id : 'faq',
					title: this.$page.props.translations.faq,
					content: {
						type: 'Accordion',
						value: [
							{
								title: 'Am primit un produs defect, ce trebuie sa fac?',
								content : `Contacteaza-ne la numarul ${contact_information.phones[0].value}, sau prin e-mail: ${contact_information.email} completand formularul disponibil in sectiunea Retur si garantie.`
							},
							{
								title: 'Cum verific daca produsul este eligibil pentru retur?',
								content : 'Un produs este eligibil pentru retur daca este in aceeasi stare in care a fost livrat (nu prezinta: zgarieturi, deteriorari, accesorii lipsa, ambalaj incomplet)'
							},
							{
								title: 'In cat timp primesc banii inapoi in urma returului efectuat?',
								content : 'Banii se pot returna in termen de maxim 14 zile de la primirea produsului de catre Erotic24, in contul indicat la completarea formularului de retur. Daca plata a fost efectuata cu card bancar online, restituirea se va efectua in contul respectiv.'
							}
						]
					}
				}
			];

      this.tabs = storeConfig.product_page.product_details_tabs.map(tabId =>
        availableTabs.filter(availableTab => availableTab.id == tabId)[0] || false
      );

		},

		buildProductAttributeOptionsArray() {

			var vm = this;

			this.product.product_attribute_options.map(product_attribute => {
				vm.product_attribute_options.push({
					key: product_attribute.attribute.translation?.value,
					value: product_attribute.option.translation?.value
				});

			});

		},
	}
}
</script>

<style scoped>

</style>